import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

const createPlaybook = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook`;
  return backend.post(url, body);
};

const listPlaybooks = () => {
  const url = `${WORKFLOW_ENGINE_API}/playbook`;
  return backend.get(url);
};

const getPlaybook = (playbookRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.get(url);
};

const updatePlaybookContent = (playbookRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.put(url, body);
};

const deletePlaybook = (playbookRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.delete(url);
};

const addPlaybookStep = (playbookRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step`;
  return backend.post(url, body);
};

const updatePlaybookStep = (playbookRn, stepRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step/${stepRn}`;
  return backend.put(url, body);
};

const removePlaybookStep = (playbookRn, stepRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step/${stepRn}`;
  return backend.delete(url);
};

const addPlaybookRule = (playbookRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/rule`;
  return backend.post(url, body);
};

const updatePlaybookRule = (playbookRn, stepRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/rule/${stepRn}`;
  return backend.put(url, body);
};

const removePlaybookRule = (playbookRn, stepRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/rule/${stepRn}`;
  return backend.delete(url);
};

const executePlaybook = (playbookRn, resourceRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/execution`;
  return backend.post(url, {resourceRn});
};

const getPlaybookExecution = (playbookRn, executionRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/execution/${executionRn}`;
  return backend.get(url);
};

const deletePlaybookExecution = (playbookRn, executionRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/execution/${executionRn}`;
  return backend.delete(url);
};

const generateEngagementResponse = (playbookEngagementPlan) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/engagement/generate`;
  return backend.post(url, {playbookEngagementPlan});
};

export default {
  create: createPlaybook,
  list: listPlaybooks,
  get: getPlaybook,
  update: updatePlaybookContent,
  delete: deletePlaybook,
  generateEngagementResponse,

  step: {
    add: addPlaybookStep,
    update: updatePlaybookStep,
    remove: removePlaybookStep,
  },

  rule: {
    add: addPlaybookRule,
    update: updatePlaybookRule,
    remove: removePlaybookRule,
  },

  execution: {
    create: executePlaybook,
    get: getPlaybookExecution,
    delete: deletePlaybookExecution,
  },
};
